import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SharedService } from '../shared/shared.service';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class PostLoginBefrienderService implements CanActivate{

  SERVER_URL= environment.backend_server;

  constructor(
    public http:HttpClient,
    public router:Router,
    private shared_service:SharedService,
    private auth_service:AuthenticationService,
  ) { }


  canActivate(route:ActivatedRouteSnapshot,state:RouterStateSnapshot):boolean | Observable<boolean>| Promise<boolean | UrlTree>{

    return new Promise (res =>{

      if(this.auth_service.isLoggedIn()['isLoggedIn']){

        if(this.auth_service.isLoggedIn()['user_data']['type_1']=='Befriender'){
           res(true);
        }else{

             this.auth_service.removeTokenSession();
             this.router.navigate(['/login']);
             res(false);

        }

      }else{

        this.router.navigate(['/login']);
        res(false);
      }


    });

  }
}
